import VoidPreset      from './presets/VoidPreset.js'
import BloomPreset     from './presets/BloomPreset.js'
import NeonPreset      from './presets/NeonPreset.js'
import OrganicPreset   from './presets/OrganicPreset.js'
import MinimalPreset   from './presets/MinimalPreset.js'
import ParticlesPreset from './presets/ParticlesPreset.js'

export const PRESETS = [
    new VoidPreset(),
    new BloomPreset(),
    new NeonPreset(),
    new OrganicPreset(),
    new MinimalPreset(),
    new ParticlesPreset(),
]

export const getPreset = (id) => PRESETS.find(p => p.id === id)

const PRESET_CLASSES = {
    void:      VoidPreset,
    bloom:     BloomPreset,
    neon:      NeonPreset,
    organic:   OrganicPreset,
    minimal:   MinimalPreset,
    particles: ParticlesPreset,
}
export const createPreset = (id) => {
    const Cls = PRESET_CLASSES[id]
    return Cls ? new Cls() : new VoidPreset()
}

export const getAvailablePresets = (userPlan) => {
    const order = { free: 0, creator: 1, pro: 2 }
    return PRESETS.filter(p => order[p.plan] <= order[userPlan])
}
